import { useCrossSellTracker } from "@packages/polling-checker"
import { Button } from "@shopify/polaris"
import { XIcon } from "@shopify/polaris-icons"
import { observer } from "mobx-react"
import React, { useState } from "react"
import { useNavigate } from "react-router-dom"

import { CROSS_SELL_POINT_ENUM } from "@/enums/CrossSellPoint"
import { BannerEnum } from "@/models/IUserInfo"
import { FEE_WAIVER_TERMS_DETAILS_URL } from "@/pages/DeliveryGuarantee/common"
import stores from "@/stores"

import arrowRight from "./assets/arrow-right.svg"
import feeWaiverBannerLeft from "./assets/waive-subscription-fee-left-text.png"
import styles from  "./index.module.scss"


// 免订阅费活动banner
const PPIFeeWavierBanner = ({ entry }: {entry: "Dashboard" | "Billing-Waive" | "Pricing Plan"}) => {
  
  const { userInfoSore } = stores

  const navigate = useNavigate()

  const [isShowBanner, setIsShowBanner] = useState(userInfoSore.isShowBanner(BannerEnum.PPI_FEE_WAIVER_BANNER))

  // 根据入口选择对应的 cross-sell 埋点
  const crossSellPointMap = {
    "Dashboard": CROSS_SELL_POINT_ENUM.DashboardWaiveFeeBanner,
    "Billing-Waive": CROSS_SELL_POINT_ENUM.BillingWaiveFeeBanner,
    "Pricing Plan": CROSS_SELL_POINT_ENUM.PricingPlanWaiveFeeBanner,
  }

  const crossSellPoint = crossSellPointMap[entry]

  // 曝光埋点
  useCrossSellTracker(() => {
    window.CrossSellTracker?.logViewed(crossSellPoint)
  }, isShowBanner && !!crossSellPoint)

  return (
    isShowBanner && userInfoSore.isPPIEligible && userInfoSore.isNotPPIWavierActivity ? 
      <div className={styles.Container} onClick={() => {
        window.CrossSellTracker?.logClicked(crossSellPoint)
        // 跳转PP insurance前，将traceId存储到sessionStorage，避免刷新后丢失
        sessionStorage.setItem("crossSellToInsuranceTraceId", window.CrossSellTracker?.getTraceId() || "")
        navigate("/protection/general?from_action=feeWaiver")
      }}
      >
        <div className={styles.CloseButton} onClick={(e) => e.stopPropagation()}>
          <Button 
            onClick={() => {
              userInfoSore.closeBannerById(BannerEnum.PPI_FEE_WAIVER_BANNER)
              setIsShowBanner(false)
            }} 
            icon={XIcon} variant="plain"
          />
        </div>
        
      
        {/* <img onClick={() => navigate("/protection/general?from_action=feeWaiver")} src={waiveSubscriptionFeeBanner} alt="" /> */}
        <div className={styles.leftContent}>
          <img src={feeWaiverBannerLeft} />
        </div>
        <div className={styles.rightContent}>
          <div className={styles.joinButton}>
            Join now <img src={arrowRight} />
          </div>
          <div className={styles.TermLink} onClick={(e) => {
            e.stopPropagation()
            window.open(FEE_WAIVER_TERMS_DETAILS_URL)
          }}
          >
            Terms & Details
          </div>
        </div>
      </div>
      : null
  )
}

export default observer(PPIFeeWavierBanner)
